import { memo } from "react";
import { Division, TabList } from "@ir/ui";
import DeductionInformationTab from "./InformationTab";
import DeductionActivityTab from "./ActivityTab";
import DeductionConversationTab from "./ConversationTab";



const DeductionTabList = () => {
    return (
        <Division>
            <TabList className="shadow-all-none" aria-label="Deductions Drawer Tabs Panel">
                <DeductionInformationTab />
                <DeductionActivityTab />
                <DeductionConversationTab />
            </TabList>
        </Division>
    )
}

export default memo(DeductionTabList);